const EyeIcons = () => {
	return (
		<svg
		    className="ml-2 mr-1 inline"
			width="18"
			height="18"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M19.683 12.1047C18.5866 13.933 16.1121 17 12 17C7.88795 17 5.41343 13.933 4.317 12.1047C4.29195 12.063 4.2851 12.0278 4.2851 12C4.2851 11.9722 4.29195 11.937 4.317 11.8953C5.41343 10.067 7.88795 7 12 7C16.1121 7 18.5866 10.067 19.683 11.8953C19.7081 11.937 19.7149 11.9722 19.7149 12C19.7149 12.0278 19.7081 12.063 19.683 12.1047ZM12 19C17.215 19 20.2099 15.1148 21.3982 13.1334C21.8205 12.4292 21.8205 11.5708 21.3982 10.8666C20.2099 8.88521 17.215 5 12 5C6.78498 5 3.79008 8.88521 2.6018 10.8666C2.17953 11.5708 2.17953 12.4292 2.60179 13.1334C3.79008 15.1148 6.78498 19 12 19ZM13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12ZM15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
				fill="#33383F"
			/>
		</svg>
	);
};
export default EyeIcons;
